import { Action, createReducer, on } from "@ngrx/store";
import { UserPermInquriyActions } from "../actions";
import { UserPermInquiryStates } from "../states";
import { initialState } from "../states/user-permissions-inquiry.states";

export const userPermInquiryReducer = createReducer(
  initialState,
  on(
    UserPermInquriyActions.loadUserPermissionInquirySuccess,
    (state, action) => {
      const permissionTarget = action.response.app_permission_dto.filter(
        (permTarget) => !state.userPermissionTargets.includes(permTarget)
      );
      return {
        ...state,
        userPermissionTargets: [
          ...state.userPermissionTargets,
          ...permissionTarget,
        ],
      };
    }
  )
);

export function user_perm_inquiry_reducer(
  state: UserPermInquiryStates | undefined,
  action: Action
) {
  return userPermInquiryReducer(state.userPermInquiry, action);
}
